// Requires feeWaivedBannerMixin mixed in alongside this one (provides feeWaivedBannerTxt).
export default {
  data() {
    return {
      childNotifications: [],
    };
  },
  computed: {
    notifications() {
      const items = [];
      if (this.feeWaivedBannerTxt) {
        items.push({ key: 'fee-waived', text: this.feeWaivedBannerTxt, level: 'success' });
      }
      return [...items, ...this.childNotifications];
    },
  },
  methods: {
    onChildNotification(items = []) {
      this.childNotifications = items;
    },
    resetChildNotifications() {
      this.childNotifications = [];
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/depositNotificationsMixin.js